import {
  createComponent,
  EnvironmentInjector,
  EnvironmentProviders,
  inject,
  provideAppInitializer,
  Type,
} from '@angular/core';

/**
 * PrimeNG 20 adds a component's CSS only when one first renders. Markup that just carries its
 * classes (e.g. `p-button` in grid cell renderers built as HTML strings) needs it loaded up front,
 * as the PrimeNG 15 theme CSS did. Rendering one throwaway instance loads the styles; they stay.
 */
export function provideEagerPrimeNgStyles(...components: Type<unknown>[]): EnvironmentProviders {
  return provideAppInitializer(() => {
    const environmentInjector = inject(EnvironmentInjector);
    for (const component of components) {
      const ref = createComponent(component, { environmentInjector });
      ref.changeDetectorRef.detectChanges();
      ref.destroy();
    }
  });
}
